<template>
  <div class="form-date">
    <datepicker
      v-model="date"
      placeholder="選択してください"
      :id="name"
      :name="name"
      :format="format"
      :disabled="disabled"
      :input-class="['datepicker',{'is-error':error}]"
      :language="ja"
    ></datepicker>
    <label
      :for="name"
      class="label"
      :class="{'is-disabled':disabled}"
    ><img src="@/assets/images/icon_calendar.png" alt=""></label>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'

export default {
  name: 'form-date',
  components: {
    Datepicker
  },
  props: {
    value: { type: [Date, String], require: true },
    name: { type: String, require: true },
    disabled: { type: Boolean, require: false, 'default':false },
    error: { type: Boolean, require: false, 'default':false },
    dateFormat: { type: String, require: false, 'default': 'YYYY/MM/DD'  }
  },
  data() {
    return {
      format: 'yyyy/MM/dd',
      ja: ja
    };
  },
  computed: {
    date: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit("input", this.formatDate(newValue))
      }
    }
  },
  methods: {
    formatDate(value) {
      let date = this.dateFormat
      date = date.replace(/YYYY/g, value.getFullYear());
      date = date.replace(/MM/g, ('0' + (value.getMonth() + 1)).slice(-2));
      date = date.replace(/DD/g, ('0' + value.getDate()).slice(-2));
      date = date.replace(/hh/g, ('0' + value.getHours()).slice(-2));
      date = date.replace(/mm/g, ('0' + value.getMinutes()).slice(-2));
      date = date.replace(/ss/g, ('0' + value.getSeconds()).slice(-2));
      if (this.dateFormat.match(/S/g)) {
        let milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
        let length = date.match(/S/g).length;
        for (let i = 0; i < length; i++) date = date.replace(/S/, milliSeconds.substring(i, i + 1));
      }
      return date;
    }
  }
}

</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/styles";
.form-date {
  display: flex;
  align-items: center;
  @include mq-down(sm) {
    width: 100%;
    > .vdp-datepicker {
      width: 100%;
    }
  }
  > .label {
    cursor: pointer;
    &.is-disabled {
      cursor: not-allowed;
      opacity: .5;
    }
    > img {
      width: 36px;
      margin-left: 10px;
    }
  }
}
</style>
<style lang="scss">
@import "../../assets/stylesheets/styles";
.datepicker {
  display: block;
  position: relative;
  padding: 0 10px;
  width: 100%;
  height: 40px;
  background-color: $white-01;
  border-radius: 5px;
  border: 1px solid $gray-line;
  font-size: 14px;
  &::placeholder {
    color: inherit;
  }
  @include mq-up(sm) {
    width: 200px;
  }
  &:disabled {
		background-color: $gray-line;
  }
  &.is-error {
    background-color: $red-bg;
  }
}
</style>
